module.exports = __webpack_public_path__ + "components/flag/static/square/si-6b0dd4f93c7089dcb19e328de994eff0.svg";